import LegalInformationService from "@services/legal-information-service";
import { useMutation } from "react-query";

export const useDeleteLegalInformationDirectoryMutation = () => {
  return useMutation(async (id: number) => {
    return new Promise((resolve, reject) => {
      LegalInformationService.DeleteDirectory(id, (err, res) => {
        if (err || !res) {
          reject(err);
        } else {
          resolve(res.data);
        }
      });
    });
  });
};
